import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Helmet, HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
    {/* <div
      className="fixed bottom-0 top-0 right-0 z-50"
      style={{ backgroundColor: "rgba(255, 255, 255, 0)" }}
    >
      <iframe
        id="chatBot_iFrame"
        src="http://localhost:3000/iframe?botId=yesmighty"
        width="450px"
        height="100%"
        maxwidth="100%"
        // pointerEvents="none"
        frameBorder="0"
        // style={{ pointerEvents: "none" }}
      ></iframe>
    </div> */}
    {/* <div className="fixed bottom-0 top-0 right-0 z-50">
      <iframe
        id="chatBot_iFrame"
        src="https://intelliver.app/iframe?botId=ff56971e-3ae4-4dca-a0cf-cb81c7f14215"
        width="55px"
        // height="20%"
        maxwidth="100%"
        frameBorder="0"
      ></iframe>
    </div> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
